import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header from "../Home/Header";
import { MdVisibility, MdEdit, MdDelete } from "react-icons/md";
import { MdClose } from "react-icons/md";

const BASE_URL = "https://gym-invoice-back.onrender.com";

function PaymentTable() {
  const [payments, setPayments] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [viewPayment, setViewPayment] = useState(null);
  const [editPayment, setEditPayment] = useState(null);
  const [modalMessage, setModalMessage] = useState({ type: "", text: "" });
  const [dialog, setDialog] = useState({
    show: false,
    message: "",
    type: "",
    onConfirm: null,
  });

  // 🔍 Filters
  const [searchId, setSearchId] = useState("");
  const [searchBillNo, setSearchBillNo] = useState("");
  const [searchPayDate, setSearchPayDate] = useState("");
  const [searchMemberName, setSearchMemberName] = useState("");
  const [searchBranchCode, setSearchBranchCode] = useState("");
  const navigate = useNavigate();

         useEffect(() => {
                const role = sessionStorage.getItem("userRole");
                if (!role) navigate("/");
              }, [navigate]);


  useEffect(() => {
    fetchPayments();
  }, []);

  // ✅ Fetch all payments
  const fetchPayments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/payments`);

      // ⭐ Sort by latest Paid Date first
      const sorted = res.data.sort((a, b) => {
        const dateA = new Date(a.payDate);
        const dateB = new Date(b.payDate);
        return dateB - dateA;
      });

      setPayments(sorted);
    } catch (error) {
      console.error("Error fetching payments:", error);
    }
  };


  // ✅ Filter logic
const filteredPayments = payments.filter((p) => {
  const payDate = p.payDate ? p.payDate.substring(0, 10) : "";

  const matchId =
    searchId.trim() === "" ||
    p.memberId?.toLowerCase() === searchId.trim().toLowerCase();

  const matchBill =
    !searchBillNo.trim() ||
    p.billNo?.toLowerCase().includes(searchBillNo.trim().toLowerCase());

  const matchName =
    !searchMemberName.trim() ||
    p.memberName?.toLowerCase().includes(searchMemberName.trim().toLowerCase());

  const matchBranch =
    !searchBranchCode ||
    (p.branchCode || "").toLowerCase() === searchBranchCode.toLowerCase();

  const matchSingleDate =
    searchPayDate === "" || payDate === searchPayDate;

  const matchRange =
    (fromDate === "" || payDate >= fromDate) &&
    (toDate === "" || payDate <= toDate);

  return (
    matchId &&
    matchBill &&
    matchName &&
    matchBranch &&
    matchSingleDate &&
    matchRange
  );
});

const downloadPdf = async () => {
  try {
    if (!fromDate || !toDate) {
      alert("Please select both From and To dates");
      return;
    }

    const params = new URLSearchParams();

    params.append("fromDate", fromDate);
    params.append("toDate", toDate);

    if (searchBranchCode) {
      params.append("branchCode", searchBranchCode);
    }

    const res = await axios.get(
      `${BASE_URL}/api/reports/monthly?${params.toString()}`,
      {
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([res.data], {
        type: "application/pdf",
      })
    );

    const link = document.createElement("a");
    link.href = url;
    link.download = `Payment_Report_${fromDate}_to_${toDate}${
      searchBranchCode ? `_${searchBranchCode}` : ""
    }.pdf`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("PDF download failed:", error);
    alert("Failed to download PDF.");
  }
};





  // ===============================
  // ✅ Membership Type Summary
  // ===============================
  const membershipSummary = {};

  filteredPayments.forEach((p) => {
    if (!membershipSummary[p.membershipType]) {
      membershipSummary[p.membershipType] = {
        count: 0,
        totalAmount: 0,
      };
    }
    membershipSummary[p.membershipType].count++;
    membershipSummary[p.membershipType].totalAmount += Number(p.amount || 0);
  });


  // ✅ Handle input change for edit
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditPayment((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Update payment
  const handleUpdate = async () => {
    if (!editPayment) return;
    if (!editPayment.status || !editPayment.paymentMethod) {
      setModalMessage({
        type: "warning",
        text: "⚠️ Status and Payment Method are required.",
      });
      return;
    }

    try {
      await axios.put(
        `${BASE_URL}/api/payments/${editPayment.id}`,
        editPayment
      );
      setModalMessage({ type: "success", text: "✅ Payment updated successfully!" });
      setEditPayment(null);
      fetchPayments();
    } catch (error) {
      console.error("Update failed:", error);
      setModalMessage({ type: "error", text: "❌ Failed to update payment." });
    }
  };

  // ✅ Delete with confirmation dialog
  const handleDelete = (id) => {
    setDialog({
      show: true,
      type: "confirm",
      message: "⚠️ Are you sure you want to delete this payment record?",
      onConfirm: async () => {
        try {
          await axios.delete(`${BASE_URL}/api/payments/${id}`);
          fetchPayments();
          setDialog({ show: true, type: "success", message: "✅ Payment deleted successfully!" });
        } catch (error) {
          console.error("Delete failed:", error);
          setDialog({ show: true, type: "error", message: "❌ Failed to delete payment." });
        }
      },
    });
  };

  return (
    <div className="dashboard">
      <Header />

      {/* ✅ Dialog Box */}
      {dialog.show && (
        <div className="dialog-overlay">
          <div className={`dialog-box ${dialog.type}`}>
            <p>{dialog.message}</p>
            <div className="dialog-buttons">
              {dialog.type === "confirm" ? (
                <>
                  <button
                    onClick={() => {
                      dialog.onConfirm && dialog.onConfirm();
                      setDialog({ ...dialog, show: false });
                    }}
                  >
                    Yes
                  </button>
                  <button onClick={() => setDialog({ ...dialog, show: false })}>No</button>
                </>
              ) : (
                <button onClick={() => setDialog({ ...dialog, show: false })}>OK</button>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="payment-container">
        <h2>SYSTEM MANAGEMENT ➤ PAYMENT DETAILS</h2>

        {/* 🔍 Filters */}
        <div className="payment-card">
        <h2>🔍 Search Details</h2>
          <div className="filter-row">
         <div className="filter-item">
            <label>Branch Code</label>
            <select
              value={searchBranchCode}
              onChange={(e) => setSearchBranchCode(e.target.value)}
            >
              <option value="">ALL BRANCHES</option>
          <option value="KB">KB - Kesbewa</option>
                                  <option value="WB">WB - Werahera</option>
            </select>
          </div>
          </div>
        <div className="filter-row">
                                 <div className="filter-item">
          <input
            placeholder="Member ID"
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
          />
          </div>
          <div className="filter-item">
          <input
                                placeholder="Name"
                                value={searchMemberName}
                                onChange={(e) => setSearchMemberName(e.target.value)}
                              />
           </div>
           </div>
              <label htmlFor="payDate">Search by Pay Date</label>
             <input
               id="payDate"
               type="date"
               placeholder="Search by Pay Date"
               value={searchPayDate}
               onChange={(e) => setSearchPayDate(e.target.value)}
             />
             <div className="filter-row">
                         <div className="filter-item">
             <label>From Date</label>
             <input
               type="date"
               value={fromDate}
               onChange={(e) => setFromDate(e.target.value)}
             />
             </div>

               <div className="filter-item">
             <label>To Date</label>
             <input
               type="date"
               value={toDate}
               onChange={(e) => setToDate(e.target.value)}
             />
              </div>
               </div>


          <input
            placeholder="Bill No"
            value={searchBillNo}
            onChange={(e) => setSearchBillNo(e.target.value)}
          />
<button
  onClick={downloadPdf}
  disabled={!fromDate || !toDate} // optional: disable if dates not selected
>
  Generate PDF
</button>

        </div>

  {searchPayDate && (
                            <div className="payment-summary">
                              <h3>📌 Payment Summary for {searchPayDate}</h3>

                              {Object.keys(membershipSummary).length === 0 ? (
                                <p>No records found.</p>
                              ) : (
                                <ul>
                                  {Object.entries(membershipSummary).map(([type, data]) => (
                                    <li key={type} style={{ marginBottom: "5px" }}>
                                      <strong>{type}</strong> — {data.count} Memberships
                                      <span style={{ marginLeft: "15px" }}>
                                        Total: <strong>Rs. {data.totalAmount}</strong>
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          )}

        {/* ✅ Payment Table */}
        <table className="payment-table">
          <thead>
            <tr>
            <th>Branch Code</th>
              <th>Member ID</th>
              <th>Bill No</th>
              <th>Member Name</th>
              <th>Membership Type</th>
              <th>Amount</th>
              <th>Bill Cycle</th>
              <th>Paid Date</th>
              <th>Payment Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPayments.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "15px", color: "#555" }}>
                  ✅ No payments found.
                </td>
              </tr>
            ) : (
              filteredPayments.map((p) => (
                <tr key={p.id}>
                <td>{p.branchCode}</td>
                  <td>{p.memberId}</td>
                  <td>{p.billNo}</td>
                  <td className="member-name-col">{p.memberName}</td>
                  <td>{p.membershipType}</td>
                  <td>{p.amount}</td>
                    <td>{p.date ? new Date(p.date).toLocaleDateString("en-GB") : ""}</td>
                    <td>{p.payDate ? new Date(p.payDate).toLocaleDateString("en-GB") : ""}</td>
                  <td>{p.status}</td>
                  <td>
                    <div className="table-action-buttons">
                      <button onClick={() => setViewPayment(p)} className="action-btn view-btn">
                        <MdVisibility size={18} />
                      </button>
                      <button
                            onClick={() => window.open(`/payment-slip/${p.billNo}`, "_blank")}
                            className="action-btn print-btn"

                          >
                            🖨️
                          </button>
                      <button onClick={() => setEditPayment(p)} className="action-btn edit-btn">
                        <MdEdit size={18} />
                      </button>
                      <button
                        onClick={() => handleDelete(p.id)}
                        className="action-btn delete-btn"
                      >
                        <MdDelete size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>



        {/* ✅ View Modal */}
        {viewPayment && (
          <div className="modal1">
            <div className="modal1-content">

              <h4>View Payment Details</h4>
              <div className="modal1-grid">
                <div className="form-row"><label>Member ID</label><input value={viewPayment.memberId} disabled /></div>
                <div className="form-row"><label>Bill No</label><input value={viewPayment.billNo} disabled /></div>
                <div className="form-row"><label>Member Name</label><input value={viewPayment.memberName} disabled /></div>
                <div className="form-row"><label>Member Email</label><input value={viewPayment.memberEmail} disabled /></div>
                <div className="form-row"><label>Membership Type</label><input value={viewPayment.membershipType} disabled /></div>
                <div className="form-row"><label>Joined Date</label><input value={viewPayment.joinedDate} disabled /></div>
                <div className="form-row"><label>Paid Month</label><input value={viewPayment.date} disabled /></div>
                <div className="form-row"><label>Payment Date</label><input value={viewPayment.payDate} disabled /></div>
                <div className="form-row"><label>Amount</label><input value={viewPayment.amount} disabled /></div>
                <div className="form-row"><label>Status</label><input value={viewPayment.status} disabled /></div>
                <div className="form-row"><label>Payment Method</label><input value={viewPayment.paymentMethod} disabled /></div>
              </div>
              <div className="filter-buttons">
                <button onClick={() => setViewPayment(null)} className="btn btn-primary">Close</button>
              </div>
            </div>
          </div>
        )}

        {/* ✅ Edit Modal */}
        {editPayment && (
          <div className="modal1">
            <div className="modal1-content">


              {modalMessage.text && (
                <div className={`modal-message ${modalMessage.type}`}>
                  {modalMessage.text}
                </div>
              )}
              <h4>Edit Payment Details</h4>
              <div className="modal1-grid">
                <div className="form-row"><label>Member ID</label><input value={editPayment.memberId} readOnly /></div>
                <div className="form-row"><label>Member Name</label><input value={editPayment.memberName} readOnly /></div>

                <div className="form-row"><label>Paid Month</label><input type="date" name="date" value={editPayment.date} readOnly /></div>
                <div className="form-row"><label>Payment Date</label><input type="date" name="payDate" value={editPayment.payDate} readOnly /></div>
                <div className="form-row"><label>Amount</label><input type="number" name="amount" value={editPayment.amount || ""} onChange={handleEditChange} /></div>

               <div className="form-row">
                 <label>Status</label>
                 <select
                   name="status"
                   value={editPayment.status || ""}
                   onChange={handleEditChange}
                 >
                   <option value="">-- Select Status --</option>
                   <option value="Done">Done</option>
                   <option value="Absent">Absent</option>
                 </select>
               </div>

                <div className="form-row">
                  <label>Payment Method</label>
                  <select name="paymentMethod" value={editPayment.paymentMethod || ""} onChange={handleEditChange}>
                    <option value="">-- Select Method --</option>
                    <option value="Cash">Cash</option>
                    <option value="Online">Online</option>

                  </select>
                </div>
              </div>
              <div className="filter-buttons">
                <button onClick={handleUpdate} className="btn btn-primary" >Save</button>
                <button onClick={() => setEditPayment(null)} className="btn btn-primary" >Cancel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentTable;
